<template>
  <div class="rootDiv">
    <!-- 搜索栏 -->
    <div class="retrieve">
      <div class="searchDiv">
        <div class="flex flex-ac flex-wrap">
          <!-- 转赠人手机号 -->
          <div class="flex flex-ac mr-20 mb-10">
            <span class="fs-16">转赠人ID：</span>
            <el-input
                v-model="searchForm.userId"
                class="w-150"
                placeholder="请输入ID"
                clearable
                @keyup.enter.native="handleSearch"
            />
          </div>

          <!-- 接收人手机号 -->
          <div class="flex flex-ac mr-20 mb-10">
            <span class="fs-16">接收人ID：</span>
            <el-input
                v-model="searchForm.rcvUserId"
                class="w-150"
                placeholder="请输入接收人ID"
                clearable
                @keyup.enter.native="handleSearch"
            />
          </div>

          <!-- 商品名称 -->
          <div class="flex flex-ac mr-20 mb-10">
            <span class="fs-16">商品名称：</span>
            <el-input
                v-model="searchForm.detailsName"
                class="w-150"
                placeholder="请输入商品名称"
                clearable
                @keyup.enter.native="handleSearch"
            />
          </div>

          <!-- 创建时间 -->
          <div class="flex flex-ac mr-20 mb-10">
            <span class="fs-16">创建时间：</span>
            <el-date-picker
                class="w-250"
                v-model="startEndDate"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
            />
          </div>

          <!-- 操作按钮 -->
          <div class="flex flex-ac mb-10" style="margin-left: auto;">
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 表格 -->
    <div class="table-wrap">
      <TableHeightFull class="tableDiv pall-30">
        <EleTable
            ref="tableRef"
            slot="table"
            :tableData="tableData"
            :columns="columns"
            height="100%"
            :border="false"
            v-loading="tabLoading"
        />
        <PagingComponent slot="after" :page-info="pageInfo" @getTableData="getTableData" />
      </TableHeightFull>
    </div>
  </div>
</template>

<script>
import indexMixin from "@/utils/indexMixin"

export default {
  name: 'rewardRecord',
  mixins: [indexMixin],
  components: {
    "EleTable": (resolve) => require(["@/components/public/TSimpleTable"], resolve),
    "TableHeightFull": (resolve) => require(["@/components/public/TableHeightFull"], resolve),
    "PagingComponent": (resolve) => require(["@/components/public/PagingComponent"], resolve),
  },
  data() {
    return {
      tabLoading: false,
      tableData: [],
      startEndDate: [],
      searchForm: {
        userId: '',
        rcvUserId: '',
        detailsName: '',
        startTime: '',
        endTime: ''
      },
      columns: [
        {
          type: 'index',
          label: '序号',
          width: '60',
          align: 'center',
          fixed: 'left',
          index: this.indexMethod
        },
        {
          label: '赠送人ID',
          align: 'center',
          prop: 'userId',
          minWidth: 120
        },
        {
          label: '赠送人用户名',
          align: 'center',
          prop: 'userName',
          minWidth: 120
        },
        {
          label: '接受人用ID',
          align: 'center',
          prop: 'rcvUserId',
          minWidth: 120
        },
        {
          label: '接受人用户名',
          align: 'center',
          prop: 'rcvUserName',
          minWidth: 120
        },
        {
          label: '领取人电话',
          align: 'center',
          prop: 'rcvUserPhone',
          minWidth: 130
        },
        {
          label: '商品名称',
          align: 'center',
          prop: 'detailsName',
          minWidth: 150
        },
        {
          label: '订单号',
          align: 'center',
          prop: 'orderNo',
          minWidth: 180
        },
        {
          label: '创建时间',
          align: 'center',
          prop: 'createDate',
          minWidth: 160
        }
      ]
    }
  },
  mounted() {
    console.log('页面加载成功，pageInfo:', this.pageInfo)
    this.getTableData()
  },
  methods: {
    handleSearch() {
      if (this.startEndDate && this.startEndDate.length === 2) {
        this.searchForm.startTime = this.startEndDate[0]
        this.searchForm.endTime = this.startEndDate[1]
      } else {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
      }
      this.pageInfo.pageNum = 1
      this.getTableData()
    },

    handleReset() {
      this.searchForm = {
        userId: '',
        rcvUserId: '',
        detailsName: '',
        startTime: '',
        endTime: ''
      }
      this.startEndDate = []
      this.pageInfo.pageNum = 1
      this.getTableData()
    },

    getTableData() {
      this.tabLoading = true
      this.$http.get('/giveOrder/findGiveOrder', {
        params: {
          currentPage: this.pageInfo.pageNum,
          pageSize: this.pageInfo.pageSize,
          ...this.searchForm,
        }
      }).then(({ data: result }) => {
        this.tabLoading = false
        this.tableData = result.data.records || []
        this.pageInfo.total = result.data.total
        console.log('表格数据:', this.tableData)
      }).catch((err) => {
        console.error('请求失败:', err)
        this.tabLoading = false
      })
    }
  }
}
</script>

<style>
</style>
